import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SourcesPage } from "@/features/sources/sources-page";

export const Route = createFileRoute("/_authenticated/$store/sources/")({
  validateSearch: z.object({ range: z.enum(["7d", "30d", "90d"]).optional().catch(undefined) }),
  head: () => ({ meta: [{ title: "Sources · Rogue AI" }] }),
  component: SourcesPage,
});
